import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { App, PublicApp } from './App';
import { loadBackend, loadPublicClient } from './backend';
import { SLUG_RE } from './model/plans';

const root = createRoot(document.getElementById('root')!);
const failed = (e: unknown) => {
  console.error(e);
  root.render(<div className="view v-loading"><div><p>Kovio couldn’t start. Check your connection and refresh the page.</p></div></div>);
};

// Guests opening a couple's website (/their-names) get only that page: no sign-in code is downloaded.
const parts = location.pathname.split('/').filter(Boolean);
const APP_PAGES = new Set(['login', 'signup', 'forgot', 'auth', 'dashboard', 'edit']);
const isWeddingPage = parts.length === 1 && !APP_PAGES.has(parts[0]) && SLUG_RE.test(parts[0]);

if (isWeddingPage) {
  loadPublicClient().then((client) => root.render(<StrictMode><PublicApp client={client} /></StrictMode>), failed);
} else {
  loadBackend().then((backend) => root.render(<StrictMode><App backend={backend} /></StrictMode>), failed);
}
